module.exports = __webpack_public_path__ + "img/pr-7.47c6c31c.png";